import { useState, useRef, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import TemplateRequestModal from './TemplateRequestModal';
import ScrollReveal from '@/components/feature/ScrollReveal';
import BrutalCTABanner from './BrutalCTABanner';


// Detect touch/mobile device
const isTouchDevice = () =>
  typeof window !== 'undefined' &&
  ('ontouchstart' in window || navigator.maxTouchPoints > 0);

const categories = ['All', 'Agency', 'E-Commerce', 'Personal', 'Photography', 'Portfolio', 'Typography'];

// All templates: $20/month recurring
const items = [
  { id: 2,  name: 'ARK/8',               category: 'Agency',      tag: null, type: 'video', price: 20, priceId: 'template_premium',  poster: 'https://framerusercontent.com/images/e6ULDXMhILZCRqYzZOtoPJubCc.jpg', video: 'https://framerusercontent.com/assets/CqYxekPkybKUw3B9LdV4M4IdXU.mp4',  externalUrl: 'https://ark8.net/' },
  { id: 3,  name: 'Temporary State',     category: 'Typography',  tag: null, type: 'video', price: 20, priceId: 'template_standard', poster: 'https://framerusercontent.com/images/c0VWATPD5g0wT1E5YC1WqWVVILU.jpg', video: 'https://framerusercontent.com/assets/BGAzo1V2vn5iFN3Hq1y5irznAA.mp4', externalUrl: 'https://type.tmpstate.net/' },
  { id: 4,  name: 'The Blimp',           category: 'Personal',    tag: null, type: 'video', price: 20, priceId: 'template_basic',    poster: 'https://framerusercontent.com/images/T9M0du8UsfRz2SkbU6lRldJwNpo.jpg', video: 'https://framerusercontent.com/assets/3BCyyBBEO3jKbpjCjrGQsZgCTTY.mp4', externalUrl: 'https://www.blimp.gr/' },
  { id: 5,  name: 'Laxer',               category: 'Agency',      tag: null, type: 'video', price: 20, priceId: 'template_standard', poster: 'https://framerusercontent.com/images/83JEHDVVEQAkjP06IedBvGYBoMQ.jpg',  video: 'https://framerusercontent.com/assets/u3d0RGj20zs8rdTcxTOhBI3wu6g.mp4', externalUrl: 'https://davidlaxer.com/' },
  { id: 6,  name: 'Duncan Brazzil',      category: 'Personal',    tag: null, type: 'video', price: 20, priceId: 'template_basic',    poster: 'https://framerusercontent.com/images/ZASZrm2Fw9By3Qs9Fr0zjMp8.jpg',    video: 'https://framerusercontent.com/assets/CbGzVkrnxt0iGjhv3MfnTeZhClo.mp4', externalUrl: 'https://duncanbrazzil.com/' },
  { id: 7,  name: 'Cristina Gómez',      category: 'Photography', tag: null, type: 'video', price: 20, priceId: 'template_standard', poster: 'https://framerusercontent.com/images/zzgoMOtxNaR7UN3mk2rvvlaIfg.jpg',   video: 'https://framerusercontent.com/assets/dSX9NrSdHBrCYBNep5R1Cr7t2Q.mp4', externalUrl: 'https://cristinagomezruiz.com/' },
  { id: 8,  name: 'Pangram Pangram',     category: 'Typography',  tag: null, type: 'video', price: 20, priceId: 'template_premium',  poster: 'https://framerusercontent.com/images/cTICgYKnabvsGNq4NzM3wybiyM.jpg',  video: 'https://framerusercontent.com/assets/86vG8jhZVdaiQ4wCLPLDS7lKSfk.mp4', externalUrl: 'https://pangrampangram.com/' },
  { id: 9,  name: 'Basement Foundry',    category: 'Agency',      tag: null, type: 'video', price: 20, priceId: 'template_premium',  poster: 'https://framerusercontent.com/images/vwi0dMlnXI4rRixNYrBJDN8iw.jpg',   video: 'https://framerusercontent.com/assets/aWM7m7beeS1Z1xVB1sgEgjHCZGc.mp4', externalUrl: 'https://foundry.basement.studio/' },
  { id: 10, name: 'Two Times Elliott',   category: 'Agency',      tag: null, type: 'video', price: 20, priceId: 'template_standard', poster: 'https://framerusercontent.com/images/DAbTwqeO5EgJ0TBK8DXFBQt6N5E.jpg', video: 'https://framerusercontent.com/assets/LmaLe1EHIVpe70oWoqqQULaNXrQ.mp4', externalUrl: 'https://xx.studio/' },
  { id: 11, name: 'Way TV',              category: 'Personal',    tag: null, type: 'video', price: 20, priceId: 'template_basic',    poster: 'https://framerusercontent.com/images/5ySCoIcmnYzqGmnyXwYQg2L8cNk.jpg',  video: 'https://framerusercontent.com/assets/qxws4EZ4hJhr28fsMMheGA3cms.mp4',  externalUrl: 'https://www.waytv.paris/' },
  { id: 12, name: 'Cristian Oliva',      category: 'Photography', tag: null, type: 'video', price: 20, priceId: 'template_standard', poster: 'https://framerusercontent.com/images/O8dg50dwpeCMCRS3oYRocRqHVlw.jpg',  video: 'https://framerusercontent.com/assets/VOVLMQHMQGEkK7BGpGfB0GRTbU.mp4', externalUrl: 'https://cristianoliva-studio.com/' },
  { id: 13, name: 'Bennett & Clive',     category: 'Agency',      tag: null, type: 'video', price: 20, priceId: 'template_premium',  poster: 'https://framerusercontent.com/images/p6mMDXyIn27rrbFoqzWPqY8ycY.jpg',  video: 'https://framerusercontent.com/assets/e3FJErSuGLir8whrL621Xo1A.mp4',   externalUrl: 'https://bennettandclive.com/' },
  { id: 14, name: 'Seb Martinez',        category: 'Portfolio',   tag: null, type: 'video', price: 20, priceId: 'template_standard', poster: 'https://framerusercontent.com/images/0TPrKxo5EtAtKaLGa0fuxurrGc.jpg',  video: 'https://framerusercontent.com/assets/PRCD1ZRC30bgMNJB8MAxkb3PvRU.mp4', externalUrl: 'https://www.sebastian-martinez.com/' },
  { id: 15, name: 'WOW Page',            category: 'Agency',      tag: null, type: 'video', price: 20, priceId: 'template_premium',  poster: 'https://framerusercontent.com/images/Ner5d3W6q58YuIth9mkA57fpJY.jpg',  video: 'https://framerusercontent.com/assets/SVVE9i7OvCFZeJdrA63ZLXnB2Sc.mp4', externalUrl: 'https://wowpage.io/' },
  { id: 16, name: 'Monolith',            category: 'Agency',      tag: null, type: 'video', price: 20, priceId: 'template_standard', poster: 'https://framerusercontent.com/images/WOJESlfM8g3BKy6YGPNohTHIjq0.jpg', video: 'https://framerusercontent.com/assets/TWokztFxBqnGi61NMuBFkPbvQTY.mp4', externalUrl: 'https://monolith.nyc/' },
  { id: 17, name: 'Synchrodogs',         category: 'Photography', tag: null, type: 'video', price: 20, priceId: 'template_basic',    poster: 'https://framerusercontent.com/images/PMrTRfuxurVEqOOXqOK9w6LQlMY.jpg', video: 'https://framerusercontent.com/assets/Jwv1TBVI0Q2GbX44K3ozRgZWyg.mp4',  externalUrl: 'https://synchrodogs.com/' },
  { id: 18, name: 'MAPP MTL',            category: 'Agency',      tag: null, type: 'video', price: 20, priceId: 'template_standard', poster: 'https://framerusercontent.com/images/iC3r0RMrmayep4S9oR79GTcazM.jpg',  video: 'https://framerusercontent.com/assets/DtJDIFWaLlGhTmEhxq12M1zNkg.mp4', externalUrl: 'https://perspectives.mappmtl.com/en' },
  { id: 19, name: 'Isabel Moranta',      category: 'Photography', tag: null, type: 'video', price: 20, priceId: 'template_basic',    poster: 'https://framerusercontent.com/images/oUQ1oNH5J3Psn4UIVYObS3i1M4.jpg',  video: 'https://framerusercontent.com/assets/69AbcKkk3GjiohDghLZS4J6vLc.mp4', externalUrl: 'https://www.isabelmoranta.com/' },
  { id: 20, name: 'Baillat Studio',      category: 'Agency',      tag: null, type: 'video', price: 20, priceId: 'template_premium',  poster: 'https://framerusercontent.com/images/rgIxF3ESanq7Et1J3TFeZ2RlCY8.jpg', video: 'https://framerusercontent.com/assets/YqWeFmzmJGGWk8AHfSJWVWp3bk.mp4', externalUrl: 'https://baillatstudio.com/en' },
  { id: 21, name: 'Duties',              category: 'E-Commerce',  tag: null, type: 'video', price: 20, priceId: 'template_standard', poster: 'https://framerusercontent.com/images/5GJYTYQZKnkyUjP4HnrTjSQwM8.jpg',  video: 'https://framerusercontent.com/assets/crMZvClCCb54u19UvguuATNz7Yo.mp4', externalUrl: 'https://www.duties.xyz/' },
  { id: 22, name: 'Thibaud Fellay',      category: 'Photography', tag: null, type: 'video', price: 20, priceId: 'template_basic',    poster: 'https://framerusercontent.com/images/FWgUvc3HEuvVslrFiTyx03Myum8.jpg', video: 'https://framerusercontent.com/assets/TocpCFYjsr1jHyEXq17Y9AM2Z4.mp4', externalUrl: 'https://thibaud.film/' },
  { id: 23, name: 'Mouthwash Studio',    category: 'Agency',      tag: null, type: 'video', price: 20, priceId: 'template_premium',  poster: 'https://framerusercontent.com/images/Ho7aF6AplOV0ECKQ28BH6Zs4ro.jpg', video: 'https://framerusercontent.com/assets/x4ZQsu5FpLH3X068KB5zmqrpMU.mp4', externalUrl: 'https://mouthwash.studio/' },
  { id: 24, name: 'Designed By Paul',    category: 'Portfolio',   tag: null, type: 'video', price: 20, priceId: 'template_premium',  poster: 'https://framerusercontent.com/images/UemC1GXM0PMW70uu5EFwquVsE.jpg',   video: 'https://framerusercontent.com/assets/Qfus5tpOPTwHdCzAb0rlCkcbAw.mp4', externalUrl: 'https://designedbypaul.com/' },
  { id: 25, name: 'Basement Studio',     category: 'Agency',      tag: null, type: 'video', price: 20, priceId: 'template_standard', poster: 'https://framerusercontent.com/images/VDHgOeTX1mEsJrKTbx0Npw6iCA.jpg',  video: 'https://framerusercontent.com/assets/D5jQ0X4kuKUlhVFAPpJixqHubbY.mp4', externalUrl: 'https://basement.studio/' },
  { id: 26, name: 'Stenger Bikes',       category: 'E-Commerce',  tag: null, type: 'video', price: 20, priceId: 'template_standard', poster: 'https://framerusercontent.com/images/gUIyOc39A2RqYIDmowSsGlvYc4.jpg',  video: 'https://framerusercontent.com/assets/B6Vstm7729bd35NvlIdEfiIYVQM.mp4', externalUrl: 'https://stenger-bike.de/en/' },
  { id: 27, name: 'Vikki Breusova',      category: 'Portfolio',   tag: null, type: 'video', price: 20, priceId: 'template_basic',    poster: 'https://framerusercontent.com/images/ybFrI0VVoqOuDkOx1GAnWgoOLk.jpg',  video: 'https://framerusercontent.com/assets/76X4LMtp7UZQ7eSzVnPlFHbJBs.mp4', externalUrl: 'https://www.vikkibre.com/' },
  { id: 28, name: 'Locomotive',          category: 'Agency',      tag: null, type: 'video', price: 20, priceId: 'template_premium',  poster: 'https://framerusercontent.com/images/MMq1w7NGCjsWaOYc6qDsfvlepo.jpg',  video: 'https://framerusercontent.com/assets/O4vW6m6QRcUgjwXB20ZDZvn4.mp4',   externalUrl: 'https://locomotive.ca/en' },
];

export type TemplateItem = typeof items[0];

function GalleryCard({ item, onSelect }: { item: TemplateItem; onSelect: (item: TemplateItem) => void }) {
  const [hovered, setHovered] = useState(false);
  const [inView, setInView] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);
  const cardRef = useRef<HTMLDivElement>(null);
  const touch = isTouchDevice();
  const navigate = useNavigate();

  // Intersection Observer for mobile autoplay
  useEffect(() => {
    if (!touch || !cardRef.current) return;
    const observer = new IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      { threshold: 0.55 }
    );
    observer.observe(cardRef.current);
    return () => observer.disconnect();
  }, [touch]);

  // Play/pause logic
  useEffect(() => {
    if (!videoRef.current) return;
    const shouldPlay = touch ? inView : hovered;
    if (shouldPlay) {
      videoRef.current.play().catch(() => {});
    } else {
      videoRef.current.pause();
      if (!touch) videoRef.current.currentTime = 0;
    }
  }, [hovered, inView, touch]);

  const isActive = touch ? inView : hovered;

  return (
    <div
      ref={cardRef}
      className="flex flex-col group cursor-pointer"
      style={{ fontFamily: "'Inter', sans-serif" }}
      onMouseEnter={() => !touch && setHovered(true)}
      onMouseLeave={() => !touch && setHovered(false)}
      onClick={() => onSelect(item)}
    >
      {/* Thumbnail */}
      <div className="relative overflow-hidden border border-black/8 bg-black" style={{ aspectRatio: '4/3' }}>
        <img
          src={item.poster}
          alt={item.name}
          className="absolute inset-0 w-full h-full object-cover object-top transition-opacity duration-300"
          style={{ opacity: isActive && item.type === 'video' ? 0 : 1 }}
        />

        {item.type === 'video' && (item as any).video && (
          <video
            ref={videoRef}
            src={(item as any).video}
            poster={item.poster}
            loop
            muted
            playsInline
            preload="none"
            className="absolute inset-0 w-full h-full object-cover object-top transition-opacity duration-300"
            style={{ opacity: isActive ? 1 : 0 }}
          />
        )}

        {/* Dark overlay + CTA on hover / in-view (mobile) */}
        <div
          className="absolute inset-0 flex flex-col items-center justify-center gap-3 transition-opacity duration-200"
          style={{ opacity: isActive ? 1 : 0, background: 'rgba(0,0,0,0.45)', pointerEvents: isActive ? 'auto' : 'none' }}
        >
          <span className="text-white text-xs font-bold uppercase tracking-widest">Select This Template</span>
          <div className="flex items-center gap-2">
            <button
              onClick={(e) => { e.stopPropagation(); navigate(`/preview/${item.id}`); }}
              className="px-4 py-1.5 bg-white text-black text-xs font-bold rounded-full whitespace-nowrap cursor-pointer hover:bg-black hover:text-white transition-colors"
            >
              View Template
            </button>
            <button
              onClick={(e) => { e.stopPropagation(); onSelect(item); }}
              className="px-4 py-1.5 bg-transparent border border-white text-white text-xs font-bold rounded-full whitespace-nowrap cursor-pointer hover:bg-white hover:text-black transition-colors"
            >
              Build for me
            </button>
          </div>
        </div>
      </div>

      {/* Title row */}
      <div className="flex items-center justify-between pt-2 pb-1 min-h-[32px]">
        <a
          href={item.externalUrl}
          target="_blank"
          rel="noopener noreferrer nofollow"
          onClick={(e) => e.stopPropagation()}
          className="text-sm text-black hover:opacity-50 transition-opacity underline underline-offset-2 decoration-black/20 cursor-pointer whitespace-nowrap overflow-hidden text-ellipsis"
        >
          {item.name}
        </a>
        <div className="flex items-center gap-2 flex-shrink-0 ml-2">
          <a
            href={item.externalUrl}
            target="_blank"
            rel="noopener noreferrer nofollow"
            aria-label="View Site"
            onClick={(e) => e.stopPropagation()}
            className="text-black/40 hover:text-black transition-colors cursor-pointer"
          >
            <i className="ri-eye-line text-sm"></i>
          </a>
          <button
            onClick={(e) => { e.stopPropagation(); onSelect(item); }}
            aria-label="Select Template"
            className="text-black/40 hover:text-black transition-colors cursor-pointer"
          >
            <i className="ri-add-circle-line text-sm"></i>
          </button>
        </div>
      </div>

      <p className="text-xs text-black/35 mt-0.5">{item.category}</p>
    </div>
  );
}

export default function BrutalGrid() {
  const [activeCategory, setActiveCategory] = useState('All');
  const [selectedTemplate, setSelectedTemplate] = useState<TemplateItem | null>(null);
  const [searchQuery, setSearchQuery] = useState('');
  const filtered = useMemo(() => {
    let result = activeCategory === 'All' ? items : items.filter(i => i.category === activeCategory);
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      result = result.filter(i => i.name.toLowerCase().includes(q) || i.category.toLowerCase().includes(q));
    }
    return result;
  }, [activeCategory, searchQuery]);

  return (
    <div style={{ fontFamily: "'Inter', sans-serif" }}>
      {/* CTA Banner */}
      <BrutalCTABanner />

      {/* Search bar — full width above tabs */}
      <ScrollReveal direction="up" duration={700} delay={0} distance={24}>
        <div className="max-w-[1400px] mx-auto px-5 pt-6 pb-4">
          <div className="relative w-full">
            <i className="ri-search-line absolute left-5 top-1/2 -translate-y-1/2 text-black/30 text-lg"></i>
            <input
              type="text"
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
              placeholder="Search templates by name or category..."
              className="w-full pl-12 pr-12 py-3.5 text-base border border-black/20 rounded-full bg-white text-black placeholder-black/30 focus:outline-none focus:border-black transition-colors"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery('')}
                className="absolute right-5 top-1/2 -translate-y-1/2 text-black/30 hover:text-black cursor-pointer"
              >
                <i className="ri-close-line text-lg"></i>
              </button>
            )}
          </div>
        </div>
      </ScrollReveal>

      {/* Category filter pills */}
      <ScrollReveal direction="up" duration={700} delay={80} distance={20}>
        <div className="max-w-[1400px] mx-auto px-5 pb-3 flex flex-wrap gap-2">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className="px-4 py-1.5 text-sm border transition-all duration-150 cursor-pointer whitespace-nowrap"
              style={{
                borderRadius: '999px',
                background: activeCategory === cat ? 'black' : 'white',
                color: activeCategory === cat ? 'white' : 'black',
                borderColor: activeCategory === cat ? 'black' : 'rgba(0,0,0,0.2)',
                fontWeight: activeCategory === cat ? 600 : 400,
              }}
            >
              {cat}
            </button>
          ))}
        </div>
      </ScrollReveal>

      {/* Results count */}
      {(searchQuery || activeCategory !== 'All') && (
        <div className="max-w-[1400px] mx-auto px-5 pb-2">
          <p className="text-xs text-black/40">{filtered.length} template{filtered.length !== 1 ? 's' : ''} found</p>
        </div>
      )}

      {/* Grid — locked for non-owners after first 3 */}
      <div className="max-w-[1400px] mx-auto px-5 pb-16">
        {filtered.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-24 text-center">
            <i className="ri-search-line text-3xl text-black/20 mb-3"></i>
            <p className="text-sm font-semibold text-black/40">No templates found</p>
            <p className="text-xs text-black/30 mt-1">Try a different search or category</p>
            <button onClick={() => { setSearchQuery(''); setActiveCategory('All'); }} className="mt-4 text-xs text-black underline cursor-pointer">Clear filters</button>
          </div>
        ) : (
          <div className="relative">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-5 gap-y-8">
              {filtered.map((item, index) => {
                return (
                  <ScrollReveal
                    key={item.id}
                    direction="up"
                    duration={650}
                    delay={Math.min((index % 3) * 80, 200)}
                    distance={32}
                    threshold={0.08}
                  >
                    <GalleryCard item={item} onSelect={setSelectedTemplate} />
                  </ScrollReveal>
                );
              })}
            </div>


          </div>
        )}

        <div className="flex items-center justify-end gap-6 mt-10 border-t border-black/10 pt-5">
          <button className="text-sm text-black hover:opacity-50 transition-opacity cursor-pointer whitespace-nowrap">Search</button>
          <button className="text-sm text-black hover:opacity-50 transition-opacity cursor-pointer whitespace-nowrap">Submit</button>
        </div>
      </div>

      <TemplateRequestModal
        template={selectedTemplate}
        onClose={() => setSelectedTemplate(null)}
      />
    </div>
  );
}
